import type { TOC } from '@ember/component/template-only';

import Default from 'umg-ember-backend/components/record-detail/for/default';
import ActionModel from 'umg-ember-backend/models/action';

interface ActionsNewRouteSignature {
  Args: {
    model: ActionModel;
  };
}

<template>
  <Default @model={{@model}} />
</template> satisfies TOC<ActionsNewRouteSignature>;
